<template>
    <div>
        <a-modal
            title="审核不通过"
            :width="420"
            :visible="visible"
            :confirmLoading="false"
            :maskClosable="false"
            @ok="() => { $emit('ok') }"
            @cancel="() => { $emit('cancel') }"
        >
            <a-spin :spinning="loading">
                <a-form-model ref="refuseForm" :model="form" :label-col="{span:4}" :wrapper-col="{span:18}" autoComplete="off">
                    <a-form-model-item label="原因" prop="reason"
                        :rules="[
                            {required: true, message: '必填，不能为空', trigger: 'blur'}
                        ]"
                    >
                        <a-select default-value="" @change="handleChange">
                            <a-select-option value="色情">
                                色情
                            </a-select-option>
                            <a-select-option value="低俗">
                                低俗
                            </a-select-option>
                            <a-select-option value="辱骂">
                                辱骂
                            </a-select-option>
                            <a-select-option value="政治">
                                政治
                            </a-select-option>
                            <a-select-option value="暴力血腥">
                                暴力血腥
                            </a-select-option>
                            <a-select-option value="违法与涉毒">
                                违法与涉毒
                            </a-select-option>
                            <a-select-option value="其他">
                                其他
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>
                    <a-form-model-item label="其他" prop="other">
                        <a-textarea v-model="form.other" style="height:48px;" />
                    </a-form-model-item>
                </a-form-model>
            </a-spin>
        </a-modal>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        loading: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            form: {
                ids: [],
                reason: '',
                other: ''
            }
        }
    },
    methods: {
        handleChange(value) {
            this.form.reason = value;
        }
    }
}
</script>

<style scoped lang="less">

</style>